<template>
  <div class="basket">
    <div
      class="basket-header text-center text-uppercase text-info font-weight-bold d-flex justify-content-center align-items-center"
    >
      <span class="mr-2">Twój koszyk</span>
      <BasketIcon />
    </div>
    <div class="container my-2" v-if="basket.baskets.length === 0">
      <div class="row">
        <div class="col-12 alert alert-dark text-center" role="alert">
          Twój koszyk jest pusty.
          <router-link
            :to="{name: 'searchPage'}"
            class="alert-link"
          >Kliknij, aby kontynuować zakupy!</router-link>
        </div>
      </div>
    </div>
    <div v-for="b in basket.baskets" class="basket-group">
      <div class="basket-header-address">
        <span>Adres dostawy:</span>
        <span
          v-if="b.address"
          class="basket-group-delivery"
        >{{ b.address.city }}, {{ b.address.street }}</span>
      </div>


      <div v-for="position in b.positions" class="row basket-position">
        <div class="basket-photo">
          <img
            :src="[position.photo_url === '/nophoto.png' ? '//cdn01.redbay.pl/layouts/boma/img/noimg.jpg' : position.photo_url]"
            class="img-fluid"
          />
          <!-- /nophoto.png -->
          <!-- //cdn01.redbay.pl/layouts/boma/img/noimg.jpg -->
        </div>

        <div  class="basket-name">
          <router-link :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}">
            <span>{{position.name}}</span>
          </router-link>
        </div>

        <div class="basket-net price">
          <span class="basket-label">netto</span>
          <span
            class="basket-info"
          >{{priceToString(position.price_net * position.cart_quantity, currency().currency.symbol)}}</span>
        </div>
        <div class="basket-tax price">
          <span class="basket-label">netto</span>
          <span
            class="basket-info"
          >{{priceToString(position.price_tax * position.cart_quantity, currency().currency.symbol)}}</span>
        </div>
        <div class="basket-gross price">
          <span class="basket-label">brutto</span>
          <span
            class="basket-info"
          >{{priceToString(position.price_gross * position.cart_quantity, currency().currency.symbol)}}</span>
        </div>
        <div class="basket-description">
          <span class="basket-label">komentarz</span>
          <textarea
            cols="20"
            rows="1"
            v-model="position.description"
            @change="modify(position)"
            class="form-control basket-info"
          ></textarea>
        </div>

        <div class="basket-address">
          <span class="basket-label">adres dostawy</span>
          <select
            v-model="position.address_id"
            @change="modify(position)"
            class="form-control basket-info"
          >
            <option
              v-for="address in user.addresses"
              :value="address.id"
            >{{ address.city }}, {{ address.street }}</option>
          </select>
        </div>

        <div v-if="mpkEnable > 0" class="basket-mpk">
          <select v-model="position.mpk_id" @change="modify(position)" class="form-control">
            <option v-for="mpk in company.mpks" :value="mpk.mpk.id">{{mpk.mpk.name}}</option>
          </select>
        </div>

        <div class="basket-quantity">
          <div class="input-group quantity-input">
            <!--
            <div class="input-group-prepend" @click="subQuantity(position)">
              <span class="input-group-text" id="basic-addon1"><minus-icon></minus-icon></span>
            </div>
            -->
            <span class="basket-label">ilość</span>
            <input
              type="text"
              class="form-control basket-info"
              :value="position.cart_quantity"
              @keyup="verifyQuantity($event, position)"
            />
            <!--
            <div class="input-group-append" @click="addQuantity(position)">
              <span class="input-group-text"><plus-icon></plus-icon></span>
            </div>
            -->
          </div>
        </div>

        <div class="basket-delete">
          <button class="btn btn-dark text-white w-100 text-uppercase" @click="remove(position)">
            <DeleteIcon title="Usuń" />
            <span>Usuń</span>
          </button>
        </div>
      </div>

      <div class="basket-footer">
        <div class="basket-footer-label">Razem:</div>
        <div class="basket-footer-net">
          <span class="basket-footer-mobile-label">netto</span>
          <span>{{priceToString(b.price_net, currency().currency.symbol)}}</span>
        </div>
        <div class="basket-footer-tax">
          <span class="basket-footer-mobile-label">vat</span>
          <span>{{priceToString(b.price_tax, currency().currency.symbol)}}</span>
        </div>
        <div class="basket-footer-gross">
          <span class="basket-footer-mobile-label">brutto</span>
          <span>{{priceToString(b.price_gross, currency().currency.symbol)}}</span>
        </div>
      </div>
    </div>

    <div v-if="basket.mpk_summary_list.length > 0 && clientLimit >0" class="basket-group">
      <div class="col-12">Limity konsumencki</div>
      <div class="row">
        <div class="col-10 total right">Limit</div>
        <div class="col-2 price">{{priceToString(clientLimit, currency().currency.symbol)}}</div>
      </div>

      <div v-if="basket.mpk_summary_list.length > 0" class="col-12">Limity budżetów</div>
      <div
        v-if="basket.mpk_summary_list.length > 0"
        v-for="mpk in basket.mpk_summary_list"
        class="row mpk-summary"
      >
        <div class="col-10 total right">{{mpk.name}}</div>
        <div class="col-2 price">{{priceToString(mpk.limit, currency().currency.symbol)}}</div>
      </div>
    </div>

    <div class="order-header my-4 d-flex justify-content-end" v-if="basket.baskets.length > 0">
      <button type="button" class="btn btn-dark" @click="orderForm">Przejdź do zamówienia</button>
    </div>
  </div>
</template>


<script>
import DeleteIcon from "vue-material-design-icons/DeleteCircle.vue";
import BasketIcon from "vue-material-design-icons/Basket.vue";
import SubIcon from "vue-material-design-icons/minus.vue";
import PlusIcon from "vue-material-design-icons/plus.vue";
import { mapState, mapGetters } from "vuex";
import MinusIcon from "vue-material-design-icons/minus.vue";
import CalculatePrice from "./../../products/src/product/CalculatePrice";
import InfoIcon from "vue-material-design-icons/InformationVariant.vue";

export default {
  components: {
    MinusIcon,
    PlusIcon,
    DeleteIcon,
    BasketIcon,
    InfoIcon
  },

  computed: {
    ...mapState({
      basket: state => state.basket.basket,
      user: state => state.user,
      company: state => state.company,
      mpkEnable: state =>
        state.shop.settings.find(s => s.name == "B2B_MPK_ENABLED")
          ? state.shop.settings.find(s => s.name == "B2B_MPK_ENABLED").value
          : 0,
      shop: state => state.shop.settings,
      demo: state => state.demo.enabled
    }),
    ...mapGetters({
      currency: "company/selectedCurrency",
      clientLimit: "company/clientLimit"
    })
  },
  data() {
    return {
      units: { single: [], decimals: [] },
      purchaseOverbookedProducts: false
    };
  },
  methods: {
    ...CalculatePrice(),

    subQuantity(position) {
      if (position.cart_quantity > 0) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity--;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity - 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity--;
        }
        this.modify(position);
      }
    },

    addQuantity(position) {
      if (position.cart_quantity < position.quantity) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity++;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity + 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity++;
        }
        this.modify(position);
      }
    },

    verifyQuantity(ev, position) {
      let keyValue = ev.target.value;
      setTimeout(() => {
        if (keyValue == ev.target.value) {
          let val = parseFloat(keyValue.replace(",", "."));
          val = val > 0 ? parseFloat(ev.target.value.replace(",", ".")) : 1;
          if (this.units.single.indexOf(position.unit_name)) {
            val = Math.ceil(val);
          }
          if (val > position.quantity && !this.purchaseOverbookedProducts) {
            val = position.quantity;
          }
          position.cart_quantity = val;
          this.modify(position);
        }
      }, 1500);
    },

    remove(position) {
      this.$store.dispatch("basket/removePosition", position);
      this.$noty.error("Produkt usunięty z koszyka!");
    },

    modify(position) {
      this.$store.dispatch("basket/modifyPosition", position);
    },

    orderForm() {
      this.$router.replace({ name: "orderForm" });
    }
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.demo) {
      this.units = this.$config.get("basket.units");
      this.$store.dispatch("user/getAddresses");
      this.$store.dispatch("basket/data");
      this.$store.dispatch("company/mpks");
      let b2bOverbooking = this.shop.find(s => s.name == "B2B_OVERBOOKING");
      this.purchaseOverbookedProducts =
        b2bOverbooking && b2bOverbooking.value == 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/basket/src/Basket.vue